import React from 'react';

const ToHTML = ({ html, component = 'span', dataHook }) => {
  const Comp = component;
  return <Comp data-hook={dataHook} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default ToHTML;
